import { jwtDecode } from "jwt-decode";
import authService from "../services/authService";

const TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

const tokenService = {
  getAccessToken: () => {
    let token = localStorage.getItem(TOKEN_KEY);
    if (!token || token === "null") return null;
    return token;
  },
  setAccessToken: (token) => localStorage.setItem(TOKEN_KEY, token),
  getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN_KEY),
  setRefreshToken: (token) => localStorage.setItem(REFRESH_TOKEN_KEY, token),
  clearTokens: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
  getUserSub: () => {
    const token = tokenService.getAccessToken();
    if (!token) return null;
    const decoded = jwtDecode(token);
    return decoded.sub;
  },
  getUserPhoneNumber: () => {
    const token = tokenService.getAccessToken();
    if (!token) return null;
    const decoded = jwtDecode(token);
    return decoded.phone_number;
  }, 
  refreshAccessToken: async () => {
    const oldRefreshToken = tokenService.getRefreshToken();
    const userSub = tokenService.getUserSub();
    if (!oldRefreshToken || !userSub) {
      tokenService.clearTokens();
      console.log("No tokens available. Login in again");
      window.location = "/";
    }

    const response = await authService.refresh(oldRefreshToken, userSub);

    const { accessToken, refreshToken } = response.data;
    tokenService.setAccessToken(accessToken);
    tokenService.setRefreshToken(refreshToken);

    return accessToken;
  },
};

export default tokenService;
